import { ChatBotUIInfoMessage } from "@jugl-web/domain-resources/chat-bot/types";
import { forwardRef } from "react";

export interface ChatBotInfoMessageComponentProps {
  message: ChatBotUIInfoMessage;
}

export const ChatBotInfoMessageComponent = forwardRef<
  HTMLDivElement,
  ChatBotInfoMessageComponentProps
>(({ message }, ref) => {
  return (
    <div ref={ref} className="flex items-center justify-center py-5 px-2">
      <div className="bg-grey-100 rounded-3xl px-[14px] py-1.5 text-center">
        <span className="text-dark-800 font-secondary inline-block text-[13px] font-normal leading-[160%]">
          ⚡ {message.text}
        </span>
      </div>
    </div>
  );
});

ChatBotInfoMessageComponent.displayName = "ChatBotInfoMessageComponent";
